import React from "react";
import PublicMapContent from "./PublicMapContent";

const PublicMap = () => <PublicMapContent variant="page" />;

export default PublicMap;
